import type { ProjectEventName } from '@/types/projectEvents'

export const PROJECT_EVENTS = [
  'hook_event',
  'new_github_event',
  'jenkins_build_event_created',
  'project_update',
] as const satisfies readonly ProjectEventName[]

/** Lifecycle notifications nest the project; activity frames carry its UUID. */
export function projectEventId(
  type: ProjectEventName,
  data: unknown
): string | null {
  if (!data || typeof data !== 'object') return null
  if (type === 'project_update') {
    if (!('data' in data) || !data.data || typeof data.data !== 'object') {
      return null
    }
    return 'id' in data.data && typeof data.data.id === 'string'
      ? data.data.id
      : null
  }
  return 'project_id' in data && typeof data.project_id === 'string'
    ? data.project_id
    : null
}
